export default {
  bind(el, binding, vnode) {
    let ev = el.event;
    ev = e => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;

      let clickedOnExcludedEl = false;

      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          clickedOnExcludedEl = excludedEl.contains(e.target);
        }
      });

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };

    document.addEventListener('click', ev);
    document.addEventListener('touchstart', ev);
  },

  unbind(el) {
    document.removeEventListener('click', el.event);
    document.removeEventListener('touchstart', el.event);
  },
};
